import { gql } from 'apollo-angular'

import { ORGANIZATION_FIELDS } from '../../fragments/organization.fragment'

export const GET_ORGANIZATION_BY_ID = gql`
  query Organization($id: Int!) {
    Organization(id: $id) {
      ...OrganizationFields
      resellerType
      reseller {
        id
        dh_id
        name
        billingAdmins(limit: 1) {
          docs {
            id
            first_name
            last_name
            name
            email
          }
        }
      }
      billingAdmins {
        docs {
          id
          first_name
          last_name
          name
          email
        }
      }
    }
  }
  ${ORGANIZATION_FIELDS}
`
